import React from 'react'

import { HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE } from '../../_templates/Templates'
import { Label } from '../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import LocalFileInput from '../../../../../components/form/LocalFileInput'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import SliderInput from '../../../../../components/form/SliderInput'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import Accordion from '../../../../../components/structure/accordion/Accordion'
import AccordionHeader from '../../../../../components/structure/accordion/AccordionHeader'
import Grid from '../../../../../components/pdf/Grid'
import { Title } from '../../../../../components/presentation/Text'
import AccordionContent from '../../../../../components/structure/accordion/AccordionContent'
import Select from '../../../../../packages/kiti/components/form/Select'

const LogoSection = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE].includes(form.template)) return false

  const isHorizontal = [HORIZONTAL_TEMPLATE].includes(form.template)

  const LOGO_ALIGN_OPTIONS = [
    { name: 'À esquerda', id: 'start' },
    { name: 'Centralizado', id: 'center' },
    { name: 'À direita', id: 'end' }
  ]

  return (
    <FlexCol>
      <Accordion lineBorder mediumPadding={true} noRadius>
        <AccordionHeader>
          <Grid justify="space-between">
            <Title size="h6" noMargin>
              Logo
            </Title>
          </Grid>
        </AccordionHeader>
        <AccordionContent>
          <Label color="black">Adicionar logo</Label>
          <LocalFileInput
            buttonLabel="Add imagem"
            accept="image/*"
            onChange={handleChange('customLogo')}
            value={form.customLogo}
          />

          <Separator weight={3} />

          <Label>Tamanho do logo (cm)</Label>
          <SliderInput value={form.logoSize} onChange={handleChange('logoSize')} step="0.05" min="0" max="10" />

          <Separator weight={3} />
          <Label color="black">Espaçamento superior (cm)</Label>
          <SliderInput
            value={form.logoSpacing}
            onChange={handleChange('logoSpacing')}
            step="0.05"
            min="0"
            max={isHorizontal ? '3' : '1.5'}
          />

          {isHorizontal && (
            <>
              <Separator weight={3} />

              <Label color="black">Alinhamento</Label>
              <Select
                disablePagination
                onChange={handleChange('logoAlign')}
                value={form.logoAlign}
                disableEmptyOption
                options={LOGO_ALIGN_OPTIONS}
              />
            </>
          )}
        </AccordionContent>
      </Accordion>
    </FlexCol>
  )
}

export default LogoSection
